import { useEffect, useState } from 'react'
import { useAppSelector } from "../../../../../../redux/hooks"
import { getInstancesWithAdd, getInstancesWithAddglobal } from '../request/request';
import axios from 'axios';
import { utils, writeFile } from 'xlsx';
import { useCallback } from 'react';
import { useAuth } from '../../../../auth';
import Swal from 'sweetalert2';

const API_URL = process.env.REACT_APP_API_URL


type vrf = {
  vendor: string,
  vrf: string
  subscription: (string)
}
type IPType = string;

export default function Ping(props: any) {
  const validate = require('ip-validator');
  const Id = useAppSelector(state => state.SuscriptionSlice.id)
  const Type = useAppSelector(state => state.CloudSlice.Type)
  const tenant = useAppSelector(state => state.TenantSlice.id)
  const nameregion = useAppSelector(state => state.RegionSlice.name)
  const FlagReg = useAppSelector(state => state.FlagSlice.value)

  const { currentUser } = useAuth()

  const [Instancia, setInstancia] = useState([{
    id: 0,
    name: " ",
    type: ''
  }])

  const [Busqueda, setBusqueda] = useState("")
  const [listvrf, setlistvrff] = useState<vrf[]>([])


  /**********************se hizo cambio en props.id para poc******************************** */
  /**********************Llamada a axios y parse de data**********************/

  useEffect(() => {
    const fetchData = async () => {
      try {
        //if (FlagReg === true) { // en teoria recuerdo que el FlagReg era como para validar si la region cambiaba para hacer la peticion una sola vez 
          
          if (Id !== 0 && Id !== -1 && Type !== 'CloudGlobal' && currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.Ping')) {

            if (tenant === 0) {
              const instancias = await getInstancesWithAdd(Id, 'Ctx.Troubleshooting.Ping', Type, nameregion);
              if (instancias.data && instancias.data.error === 'id suscription invalido') {
                setInstancia([])
              } else {
                
                setInstancia(instancias.data)
                setBusqueda(instancias.data[0].id)
              }
            }
            else {
              const instancias = await getInstancesWithAddglobal(Id, tenant, 'Ctx.Troubleshooting.Ping', Type, nameregion);
              if (instancias.data && instancias.data.error === 'id suscription invalido') {
                setInstancia([])
              } else {
                
                setInstancia(instancias.data)
                setBusqueda(instancias.data[0].id)
              }
            }
          }
          else if (Id !== 0 && Id !== -1 && Type === 'CloudGlobal' && currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.Ping')) {

            if (tenant === 0) {
              const instancias = await getInstancesWithAdd(Id, 'Ctx.Troubleshooting.Ping');
              if (instancias.data && instancias.data.error === 'id suscription invalido') {
                setInstancia([])
              } else {
                setInstancia(instancias.data)
                setBusqueda(instancias.data[0].id)
              }
            }
            else {
              const instancias = await getInstancesWithAddglobal(Id, tenant, 'Ctx.Troubleshooting.Ping');
              if (instancias.data && instancias.data.error === 'id suscription invalido') {
                setInstancia([])
              } else {
                setInstancia(instancias.data)
                setBusqueda(instancias.data[0].id)
              }
            }
          }
       // }
      } catch (error) {
        console.error('Error al obtener las cuentas:', error);
      }
    };

    fetchData();
  }, [nameregion]
  )


  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Id !== 0 && currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.Ping')) {
          if (tenant === 0) {
            const instancias = await getInstancesWithAdd(Id, 'Ctx.Troubleshooting.Ping');
            if (instancias.data && instancias.data.error === 'id suscription invalido') {
              setInstancia([])
            } else {
              setInstancia(instancias.data)
              setBusqueda(instancias.data[0].id)
            }
          }
          else {
            const instancias = await getInstancesWithAddglobal(Id, tenant, 'Ctx.Troubleshooting.Ping');
            if (instancias.data && instancias.data.error === 'id suscription invalido') {
              setInstancia([])
            } else {
              setInstancia(instancias.data)
              setBusqueda(instancias.data[0].id)
            }

          }

        }
      } catch (error) {
        console.error('Error al obtener las cuentas:', error);
      }
    };

    fetchData();
  }, [Id]
  )

  /////////////////////////////

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Id !== 0 && Busqueda !== '') {
          for (const x of Instancia) {
            if (Number(Busqueda) === x.id) {
              if (x.type === "ctx") {
                const body =
                {
                  instanceId: Number(Busqueda),
                  suscriptionId: Id
                }
                await axios.post(API_URL + '/v1/listVrf?tenantId=' + tenant, body)
                  .then(res => {
                    setlistvrff(res.data)
                  })
              }
              else if (x.type === "add") {
                const body =
                {
                  instanceId: Number(Busqueda),
                  suscriptionId: Id
                }
                await axios.post(API_URL + '/v1/listVrf/add?tenantId=' + tenant, body)
                  .then(res => {
                    setlistvrff(res.data)
                  })
              }
            }
          }


        }
      }
      catch {
      }
    };
    fetchData();
  }, [Busqueda, Id])


  /////////////////////////////



  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Id === -1 && Type === 'CloudGlobal' && Busqueda !== '') {
          let type
          for (const x of Instancia) {
            if (Number(Busqueda) === x.id) {
              type = x.type
            }
          }

          if (type === 'ctx') {
            const body =
            {
              instanceId: Number(Busqueda),
              suscriptionId: '-1'
            }
            await axios.post(API_URL + '/v1/listVrf?tenantId=' + tenant, body)
              .then(res => {
                setlistvrff(res.data)
              })
          }
          if (type === 'add') {
            const body =
            {
              instanceId: Number(Busqueda),
              suscriptionId: '-1'
            }
            await axios.post(API_URL + '/v1/listVrf/add?tenantId=' + tenant, body)
              .then(res => {
                setlistvrff(res.data)
              })
          }
        }
      }
      catch {
      }
    };
    fetchData();
  }, [Busqueda, Id, Type])



  ////////////////////////////////////////////////////////////
  const [vrfselect, setselectvrf] = useState<any>()

  const cambiarstate = (e: any) => {
    setBusqueda(e.target.value)
  }

  const vrfseleccionada = (e: any) => {
    setselectvrf(e.target.value)
  }





  /*****************************Nuevo**************************************** */
  const [Ipdest, setIpdest] = useState('');
  const [DataPing, setDataPing] = useState(
    {
      avg: [{
        min: '',
        avg: '',
        max: '',
        mdev: ''
      }],
      list: [
        {
          ip: '',
          seq: '',
          ttl: '',
          time: ''
        }
      ],
      statistics: [{
        ptx: '',
        prx: '',
        ploss: ''
      }]
    }
  )
  /***************************SE VALIDA QUE LA IP ES UNA IP*********************************** */



  const handleSubmit = async (e: any) => {
    e.preventDefault();
    if (props.tab === 1) {

      try {
        if (Busqueda === '') {
          Swal.fire(
            'Oooops!',
            'Please select an Instance',
            'warning',
          )
        }
        else if (vrfselect === '') {
          Swal.fire(
            'Oooops!',
            'Please select a VRF',
            'warning',

          )
        }
        else if (Ipdest === '') {
          Swal.fire(
            'Oooops!',
            'Please fill in the IP field',
            'warning',

          )
        }
        else if (Busqueda !== '' && vrfselect !== '' && Ipdest !== '') {
          if (validate.ipv4(Ipdest)) {
            let type
            for (const x of Instancia) {
              if (Number(Busqueda) === x.id) {
                type = x.type
              }
            }

            const vrf = listvrf[vrfselect]
            const body = {
              ipdest: Ipdest,
              vrf: vrf,
              type: type

            }

            if (tenant === 0) {
              await axios.post(API_URL + '/v1/troubleshooting/instances/' + Busqueda, body)
                .then(res => {
                  setDataPing(res.data)
                })
            }
            else {
              await axios.post(API_URL + '/v1/troubleshooting/instances/' + Busqueda + '?tenantId=' + tenant, body)
                .then(res => {
                  setDataPing(res.data)
                })
            }
          } else {
            Swal.fire(
              'Oooops!',
              'Please enter a valid IP address.',
              'warning',

            )
          }
        }
      }
      catch (error: any) {
        console.log(error)

      }

    }
  }

  useEffect(() => {
    if (Type) {

      setDataPing({
        avg: [{
          min: '',
          avg: '',
          max: '',
          mdev: ''
        }],
        list: [
          {
            ip: '',
            seq: '',
            ttl: '',
            time: ''
          }
        ],
        statistics: [{
          ptx: '',
          prx: '',
          ploss: ''
        }]
      })
      setIpdest('')
    }
  }, [Type])


  useEffect(() => {
    if (Busqueda) {
      setselectvrf("")
    }
  }, [Busqueda])
  /********************************************* */


  const exportFile = useCallback(() => {
    // Obtén la fecha actual
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // Añade ceros a la izquierda si es necesario
    const day = currentDate.getDate().toString().padStart(2, '0');

    // Formatea la fecha en el formato deseado (por ejemplo, YYYY-MM-DD)
    const formattedDate = `${year}-${month}-${day}`;

    const dataToExport = [...DataPing.list];

    const sortedData = dataToExport.map(item => ({
      'IP': item.ip,
      'Seq': item.seq,
      'TTL': item.ttl,
      'Time': item.time,
    }));
    const dataToExportd = [...DataPing.statistics];
    const sortedDatad = dataToExportd.map(item => ({
      'Pakets Transmited': item.ptx,
      'Pakets Received': item.prx,
      'Pakets loss': item.ploss,


    }));
    const dataToExportt = [...DataPing.avg];
    const sortedDatat = dataToExportt.map(item => ({
      'rtt min': item.min,
      'avg': item.avg,
      'max': item.max,
      'mdev': item.mdev


    }));
    /* generate worksheet from state */
    const ws = utils.json_to_sheet(sortedData);
    const wsd = utils.json_to_sheet(sortedDatad);
    const wst = utils.json_to_sheet(sortedDatat);

    /* create workbook and append worksheet */
    const wb = utils.book_new();

    utils.book_append_sheet(wb, ws, "Ping Table");
    utils.book_append_sheet(wb, wsd, "Statistics Table");
    utils.book_append_sheet(wb, wst, "avg Table");


    utils.sheet_add_aoa(ws, [["IP", "Seq", "TTL", "Time"]], { origin: "A1" });
    utils.sheet_add_aoa(wsd, [["Pakets Transmited", "Pakets Received", "Pakets loss"]], { origin: "A1" });
    utils.sheet_add_aoa(wst, [["rtt min", "avg", "max", "mdev"]], { origin: "A1" });


    let nombre
    for (const x of Instancia) {
      if (Number(Busqueda) === x.id) {
        nombre = x.name
      }
    }

    /* export to XLSX */
    writeFile(wb, nombre + "_Ping_" + formattedDate + ".xlsx");
  }, [DataPing]);

  return (
    <>
      <div style={{ marginTop: '15px' }} className="f-titulo fs-md mb-3 text-marino text-center">
        Ping
      </div>
      <div
        className='stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid '
        id='kt_create_account_stepper'
      >
        {/* begin::Aside*/}
        <div className='card d-flex justify-content-center justify-content-xl-start flex-row-auto w-100 w-xl-300px w-xxl-400px me-9 border border-gray-300' style={{ marginBottom: '20px' }}>
          {/* begin::Wrapper*/}
          <div className='card-body px-6 px-lg-10 px-xxl-15 py-20'>
            {/* begin::Nav*/}
            <div className='stepper-nav'>
              {/* begin::Step 1*/}
              <div className='stepper-item current' data-kt-stepper-element='nav'>
                {/* begin::Wrapper*/}
                <div className='stepper-wrapper'>
                  {/* begin::Label*/}
                  <div className='stepper-label'>
                    <div className="d-flex flex-wrap fw-bold fs-6 mb-4 pe-2 flex-center">
                      <div className="d-flex flex-column flex-row-auto">
                        <label className='form-label f-bold fs-p text-marino required form-label' >Instance</label>
                        <select className="custom-select w-200px" aria-label="Select example"
                          onChange={cambiarstate} value={Busqueda}>
                          {Instancia.length === 0 && <option disabled selected hidden>No data</option>}
                          {Instancia.length !== 0 && <option hidden>Select an Instance </option>}
                          {Instancia.length !== 0 && Instancia?.map((ins: any, i) =>
                            <option key={i} value={ins.id}>{ins.name}</option>
                          )
                          }
                          {/*Id === -1 && Type === 'CloudGlobal' && Instancia?.map((ins: any, i) =>
                            <option key={i} value={ins.id}>{ins.name}</option>
                          )
                          */}

                        </select>
                      </div>
                      <div className='w-30px'></div>

                      <div className="d-flex flex-column flex-row-auto">
                        <label className='form-label f-bold fs-p text-marino required form-label' >VRF</label>
                        <select className="custom-select w-200px" aria-label="Select example"
                          onChange={vrfseleccionada} value={vrfselect}>
                          {listvrf?.length === 0 ? <option key={'x'} className='text-danger bg-info' hidden>No VRF</option> : <option hidden>Select an VRF </option>}

                          {Busqueda !== '' && Id !== 0 && Id !== -1 && listvrf.length !== 0 && listvrf?.map((vrf: any, i) =>
                            <>
                              {!vrf.vrf && <option key={i} value={i}>Main</option>}
                              {vrf.vrf && <option key={i} value={i}>{vrf.vrf}</option>}
                            </>
                          )
                          }

                          {Busqueda !== '' && Id === -1 && Type === 'CloudGlobal' && listvrf.length !== 0 && listvrf?.map((vrf: any, i) =>
                            <>
                              {!vrf.vrf && <option key={i} value={i}>Main({vrf.subscriptions})</option>}
                              {vrf.vrf && <option key={i} value={i}>{vrf.vrf}({vrf.subscriptions})</option>}
                            </>
                          )
                          }


                        </select>
                      </div>
                      <div className='w-30px'></div>

                      <div className="d-flex flex-column flex-row-auto">
                        <label className='form-label f-bold fs-p text-marino required form-label' >IP</label>
                        <input
                          type="text"
                          className="form-control  border-marino  f-parrafo fs-p"
                          placeholder='Write your IP'
                          value={Ipdest}
                          onChange={(e: any) => setIpdest(e.target.value)}
                        />

                      </div>
                      <div className='w-30px'></div>

                      <br />
                      <br />

                      <div className="d-flex flex-column flex-row-auto  ">
                        <br />
                        <button
                          type='submit'
                          onClick={handleSubmit}
                          className='btn-light-marino'
                        >
                          <span className='indicator-label'>Send</span>
                        </button>
                      </div>

                      <div className='w-30px'></div>
                      <div className='text-center'>
                        <br />
                        <button className="btn-light-marino" onClick={exportFile}> <i className="bi bi-download" style={{ color: 'white' }}></i> Export Excel </button>

                      </div>


                    </div>
                    {/*  <div  className="d-flex flex-column flex-row-auto  ">
                        <br />
                        <button className="btn-light-marino" onClick={exportFile}> <i className="bi bi-download" style={{color:'white'}}></i> Export Excel </button>

                              </div>*/}
                  </div>
                  {/* end::Label*/}
                </div>
                {/* end::Wrapper*/}

              </div>
              {/* end::Step 1*/}

            </div>
            {/* end::Nav*/}
          </div>
          {/* end::Wrapper*/}
        </div>
        {/* begin::Aside*/}

        <div className='d-flex flex-row-fluid  bg-body rounded border ' style={{ marginBottom: '20px' }}>
          <div className='card-body w-100'>
            <div className='pb-10 pb-lg-15'>
              <div className="card-body card-scroll  h-300px">
                <table className="w-full f-parrafo  caption-bottom  custom-table"  >
                  <thead>
                    <tr className="table-header-light bg-marino">
                      <th className='table-cell'>IP</th>
                      <th className='table-cell'>Seq</th>
                      <th className='table-cell'>TTL</th>
                      <th className='table-cell'>Time</th>
                    </tr>
                  </thead>
                  <tbody style={{ marginTop: '0px' }}>
                    {DataPing?.list !== null &&
                      DataPing?.list.map((d, i) => (
                        <tr key={i} className='table-row'>
                          <td className='table-cell'>{d.ip}</td>
                          <td className='table-cell'>{d.seq}</td>
                          <td className='table-cell'>{d.ttl}</td>
                          <td className='table-cell'>{d.time}</td>
                        </tr>


                      ))}
                  </tbody>

                </table>
              </div>
              {Id === -1 && Type !== 'CloudGlobal' &&
                <table className="w-full f-parrafo  caption-bottom  custom-table">
                  <tbody>
                    <div className="text-center">
                      Select a Cloud with available subscriptions
                    </div>
                  </tbody>
                </table>}
            </div>
            <div className='card-footer '  >
              <div className='text-center'>
                {DataPing.statistics !== null && DataPing.statistics.length !== 0 && DataPing?.statistics.map((a, b) => (
                  a.ptx !== '' &&
                  <div key={b} className='f-parrafo fs-p'>
                    <strong className='text-pink'>------ Ping Statistics ------</strong>
                    <br />
                    <br />
                    <strong className='text-pink'>{a.ptx}</strong> Pakets Transmited, <strong className='text-pink'>{a.prx}</strong> Packets Received, <strong className='text-pink'>{a.ploss}</strong> Packets Loss
                  </div>

                ))}
                <br />
                {DataPing.avg !== null && DataPing.avg.length !== 0 && DataPing?.avg.map((c, d) => (
                  c.min !== '' &&
                  <div key={d} className='f-parrafo'>
                    <strong className='text-pink'>rtt min/avg/max/mdev = </strong> {c.min}<strong className='text-pink'>/</strong>{c.avg}<strong className='text-pink'>/</strong>{c.max}<strong className='text-pink'>/</strong>{c.mdev}
                  </div>
                ))}
              </div>

            </div>

          </div>

        </div>
      </div >
    </>

  )

}
